import { render, staticRenderFns } from "./CardEditavelDemanda.vue?vue&type=template&id=d56c8be0&scoped=true&"
import script from "./CardEditavelDemanda.vue?vue&type=script&lang=js&"
export * from "./CardEditavelDemanda.vue?vue&type=script&lang=js&"
import style0 from "./CardEditavelDemanda.vue?vue&type=style&index=0&id=d56c8be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c8be0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
